import { useQuery } from '@tanstack/react-query'

import { getProductByAddress } from 'indices-list'
import { sets } from '../../../abis/set/sets'
import { IDateProvider } from '../interface/daily-capitalisation'

/**
 * Address sanitization layer
 * @param address
 * @returns
 */
export const sanitizeAddress = (address: string) => {
  return address.toLowerCase()
}

/**
 * Retrieves the subgraph URL for a given product address
 * @param address Product address
 * @returns Subgraph URL corresponding to the product's network
 */
export const getSubgraphUrl = (address: string): string => {
  const product = getProductByAddress(address)
  return sets[product.network].subgraph
}

export const getSubgraphNewUrl = (address: string): string => {
  const product = getProductByAddress(address)
  return product.subgraph
}

/**
 * @param react-query interface
 * @returns
 */
export const getGraphQlData = <T>(
  productAddress: string,
  keys: string[],
  fetchingService: () => Promise<T[]>,
) => {
  if (!keys) {
    throw new Error('Keys are required to keep the cache consistent')
  }
  const queryKey = [productAddress, ...keys]
  return useQuery(queryKey, fetchingService)
}

export const getAllgraphQlData = <T extends IDateProvider>(
  productAddress: string,
  keys: string[],
  fetchingService: () => Promise<T[]>,
) => {
  if (!keys) {
    throw new Error('Keys are required to keep the cache consistent')
  }

  const queryKey = [...[productAddress], ...keys]

  return useQuery(queryKey, fetchingService)
}
